import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import styles from './LineNavbar.css';

class LineNavbar extends React.PureComponent {
  render() {
    return (
      <div>
        <ul className={styles.list}>
          {this.props.links.map((link, index) => {
            return (
              <li
                id={link.id}
                key={index}
                className={`${styles.elmt} ${this._activeStyle(link.href)}`}
              >
                <Link
                  to={link.href}
                  onClick={e => {
                    this.props.onClickLink({ e, link });
                  }}
                >
                  {link.label}
                </Link>
              </li>
            );
          })}
          <div className="clearfix" />
        </ul>
      </div>
    );
  }

  _activeStyle = link => {
    if (
      (this.props.forceHighlight && link === '/apps/app-market') ||
      link === this.props.pathname
    ) {
      return styles.active;
    }
    return '';
  };
}

LineNavbar.propTypes = {
  links: PropTypes.array,
  pathname: PropTypes.string,
  onClickLink: PropTypes.func,
};

LineNavbar.defaultProps = {
  onClickLink() {
    /* no op */
  },
};

export default LineNavbar;
